<template>
  <div class="row">
    <div class="col-sm">
      <h4>Banned sending servers</h4>
      <p>
        Banned sending servers (PTR records) are banned from sending to specific
        customer addresses via killer.py, maybe remove this.
      </p>
      <form @submit.prevent="actionBan">
        <div class="input-group mb-3">
          <input
            type="text"
            placeholder="domain.tld or domain.tld:destination@alias.tld"
            class="form-control"
            v-model="ban"
          />
          <div class="input-group-append">
            <input
              type="submit"
              name="ban"
              value="Ban Server"
              class="btn btn-sm btn-warning"
            />
          </div>
        </div>
      </form>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Domain</th>
            <th class="text-center">Until</th>
            <th class="text-center">Strikes</th>
            <th class="text-center">Added</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="domain in domains" :key="domain.name">
            <td>
              <router-link
                :to="{ name: 'server', query: { qs: domain.name } }"
                >{{ domain.name }}</router-link
              >
            </td>
            <td class="text-center">{{ domain.until }}</td>
            <td class="text-center">{{ domain.strikes }}</td>
            <td class="text-center">{{ domain.added }}</td>
            <td class="text-center">
              <a
                href="javascript:;"
                title="Unban this domain now"
                class="btn btn-danger btn-sm"
                @click="actionUnban(domain.name)"
                >Unban</a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ban: null,
      domains: [],
    };
  },
  created() {
    this.getBannedServers();
  },
  methods: {
    async getBannedServers() {
      const response = await this.$http.get("bans");
      this.domains = response.body.domains;
    },
    async actionUnban(domain) {
      await this.$http.post("redis/" + domain + "/unlock");
      const index = this.domains.findIndex((x) => x.name === domain);
      if (index > -1) {
        this.domains.splice(index, 1);
      }
    },
    async actionBan() {
      let domain = this.ban.trim();
      if (!domain) {
        return;
      }

      domain = domain.replace("http://", "").replace("https://", "");
      const response = await this.$http.post("redis/" + domain + "/lock");

      const index = this.domains.findIndex(
        (x) => x.name === response.body.domain.name,
      );
      if (index > -1) {
        // We replace the entry
        this.domains.splice(index, 1, response.body.domain);
      } else {
        this.domains.unshift(response.body.domain);
      }
    },
  },
};
</script>
